import * as ISchema from "@schema";
import { getValue } from "@util/errorable.util";

export const OnboardingChecklistLabels = {
  lunchEnabled: "Find time for lunch",
  focusTimeEnabled: "Turn on Focus Time",
  flexMeetingEnabled: "Make a meeting flexible",
  slackEnabled: "Add Clockwise to Slack",
  inviteSent: "Invite your team",
};

export enum OnboardingChecklistTypes {
  lunchEnabled = "lunchEnabled",
  focusTimeEnabled = "focusTimeEnabled",
  flexMeetingEnabled = "flexMeetingEnabled",
  slackEnabled = "slackEnabled",
  inviteSent = "inviteSent",
}

export type OnboardingChecklistSimplified = {
  lunchEnabled: boolean;
  focusTimeEnabled: boolean;
  flexMeetingEnabled: boolean;
  slackEnabled: boolean;
  inviteSent: boolean;
};

export const createChecklistFromOrg = (org: ISchema.IOrg) => {
  // look for all keys in checklist and create a simpler
  const checklist = org.onboardingChecklist;

  let checklistObject: OnboardingChecklistSimplified = {
    lunchEnabled: false,
    focusTimeEnabled: false,
    flexMeetingEnabled: false,
    slackEnabled: false,
    inviteSent: false,
  };

  const keysToIterate = Object.keys(checklistObject);
  keysToIterate.forEach((key: OnboardingChecklistTypes) => {
    checklistObject[key] = isOnboardingItemComplete(key, checklist);
  });

  return checklistObject;
};

export const isOnboardingItemComplete = (
  itemType: OnboardingChecklistTypes,
  checklist: ISchema.IOnboardingChecklist,
) => {
  if (!checklist) return false;
  switch (itemType) {
    case OnboardingChecklistTypes.lunchEnabled:
      const lunchEnabledValue = getValue(checklist.lunchEnabled);
      return !!lunchEnabledValue ? lunchEnabledValue.lunchEnabled : false;
    case OnboardingChecklistTypes.flexMeetingEnabled:
      const flexMeetingEnabledValue = getValue(checklist.flexMeetingEnabled);
      return !!flexMeetingEnabledValue ? flexMeetingEnabledValue.flexMeetingEnabled : false;
    case OnboardingChecklistTypes.focusTimeEnabled:
      const focusTimeEnabledValue = getValue(checklist.focusTimeEnabled);
      return !!focusTimeEnabledValue ? focusTimeEnabledValue.focusTimeEnabled : false;
    case OnboardingChecklistTypes.slackEnabled:
      const slackEnabledValue = getValue(checklist.slackEnabled);
      return !!slackEnabledValue ? slackEnabledValue.slackEnabled : false;
    case OnboardingChecklistTypes.inviteSent:
      const inviteSentValue = getValue(checklist.hasInvitedTeammate);
      return !!inviteSentValue ? inviteSentValue.hasInvitedTeammate : false;
    default:
      return false;
  }
};

// sort the complete (true) items to the top if there are any
export const sortedChecklistItems = (checklist?: OnboardingChecklistSimplified) => {
  if (!checklist) return [];
  const objectKeys = Object.keys(checklist) as [OnboardingChecklistTypes];
  return objectKeys.sort((a, b) => Number(checklist[b]) - Number(checklist[a]));
};

export const numberOfOnboardingChecklistItemsComplete = (
  checklist?: OnboardingChecklistSimplified,
) => {
  if (!checklist) return 0;
  let countComplete = 0;
  Object.keys(checklist).forEach((item: OnboardingChecklistTypes) => {
    if (checklist[item]) {
      countComplete = countComplete + 1;
    }
  });
  return countComplete;
};
